import DynamicForm, { DynamicFormRef } from "@mavichpe/dynamic-forms";
import { forwardRef, useEffect, useRef } from "react";
import ClientSettlementsReportFormConfig from "./form";
import { Button, Col, Row } from "reactstrap";
import moment from "moment";
import { ClientSettlementsReportFormDataType } from "@/formTypes/ClientSettlementsReportFormDataType";
import { REPORT_EXCEL_FORMAT, REPORT_PRINT_FORMAT } from "@utils/Constants";

type ClientSettlementsReportFormProps = {
}

const ClientSettlementsReportForm = forwardRef<DynamicFormRef, ClientSettlementsReportFormProps>(
  (_props, _ref) => {
    const formRef = useRef<DynamicFormRef>(null);

    useEffect(() => {
      const previousMonth = moment().subtract(1, "month");
      const startDate = previousMonth.startOf("month").format("YYYY-MM-DD");
      const endDate = moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD");
      formRef.current?.resetFormValue({
        clientId: "-2",
        zoneId: "-2",
        startDate,
        endDate,
        excludeAnuladas: false,
      })
    }, [])

    const getFormConfig = () => {
      return ClientSettlementsReportFormConfig;
    }

    const generateForm = (formData: ClientSettlementsReportFormDataType) => {
      const { clientId, zoneId, startDate, endDate } = formData;
      const excludeAnuladas = formData.excludeAnuladas ? "1" : "0";
      if (formData.format == REPORT_PRINT_FORMAT) {
        window.open(`/user/reports/print/clientSettlements/${clientId}/${zoneId}/${startDate}/${endDate}/${excludeAnuladas}`, "_blank")
      } else if (formData.format == REPORT_EXCEL_FORMAT) {
        window.open(`/user/reports/excel/clientSettlements/${clientId}/${zoneId}/${startDate}/${endDate}/${excludeAnuladas}`, "_blank")
      }
    }

    return (
      <>
        <DynamicForm<ClientSettlementsReportFormDataType>
          ref={formRef}
          id="clientSettlementsReport"
          formConfig={getFormConfig()}
          onSubmit={generateForm}
        >
          <Row>
            <Col md={{
              offset: 2
            }}>
              <Button className="me-3" type="submit" color="primary" size="lg">Generar Reporte</Button>
            </Col>
          </Row>
        </DynamicForm>
      </>
    )
  }
);

export default ClientSettlementsReportForm;
